import { render, staticRenderFns } from "./TemplateMessageModal.vue?vue&type=template&id=3a805380&scoped=true"
import script from "./TemplateMessageModal.vue?vue&type=script&lang=js"
export * from "./TemplateMessageModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateMessageModal.vue?vue&type=style&index=0&id=3a805380&prod&lang=scss&scoped=true"
import style1 from "./TemplateMessageModal.vue?vue&type=style&index=1&id=3a805380&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a805380",
  null
  
)

export default component.exports